/**
 * API 基地址：优先 window.__ENV__.VITE_APP_API_BASE_URL（运行时注入），
 * 否则使用构建时 import.meta.env.VITE_APP_API_BASE_URL；
 * 均为空则返回 ''，axios 使用相对路径，开发环境由 Vite /api 代理承接。
 */
export function getApiBaseUrl() {
  // 运行时注入优先（即使是空字符串也表示“显式走同源 /api 代理”）
  if (
    typeof window !== 'undefined' &&
    window.__ENV__ &&
    Object.prototype.hasOwnProperty.call(window.__ENV__, 'VITE_APP_API_BASE_URL')
  ) {
    const runtimeRaw = window.__ENV__.VITE_APP_API_BASE_URL
    const runtime = runtimeRaw == null ? '' : String(runtimeRaw).trim()
    return runtime.replace(/\/$/, '')
  }

  const buildRaw = import.meta.env.VITE_APP_API_BASE_URL
  const build = buildRaw == null ? '' : String(buildRaw).trim()
  return build.replace(/\/$/, '')
}
